module.exports = __webpack_public_path__ + "static/media/3DPPA12.325698c6.jpg";